export function groupByMultipleKeys(objectArray, properties) {
  return objectArray.reduce(function (acc, obj) {
    var key1 = obj[properties[0]];
    var key2 = obj[properties[1]];

    if (!acc[key1]) {
      acc[key1] = {};
    }

    if (!acc[key1][key2]) {
      acc[key1][key2] = [];
    }

    acc[key1][key2].push(obj);
    return acc;
  }, {});
}

export function groupBy(objectArray, property) {
  return objectArray.reduce(function (acc, obj) {
    var key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
}
